// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2f0f7b05","977":"6da74fb7"}[chunkId] + ".chunk.js";
};